import { OfferDesignTypes } from 'views/OffersUI/OffersUIForm/types';

import { FilterOption } from 'components/FilterComponents/FilterPopover/types';

export const OFFER_TYPE_FILTER_OPTIONS: FilterOption[] = [
    { label: 'Special Offer', value: OfferDesignTypes.SpecialOffer },
    { label: 'Bundle', value: OfferDesignTypes.Bundle },
    { label: 'Pop Up', value: OfferDesignTypes.PopUp },
    { label: 'Rolling Offer', value: OfferDesignTypes.RollingOffer },
    { label: 'Progress Bar', value: OfferDesignTypes.ProgressBar }
];

export const BUTTON_TEXT = 'Create New Offer Design';

export const FILTER_PARAM_EXTERNAL_ID = 'externalId';
export const FILTER_PARAM_NAME = 'name';
export const FILTER_PARAM_TYPE = 'type';
export const FILTER_TYPE_SEPARATOR = ',';
